<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row no-gutter justify-center items-center">
                        <div class="vx-col hidden lg:block lg:w-1/2">
                            <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">登录</h4>
                                    <p>欢迎回来,请登录您的账号</p>
                                </div>
                                <vs-input
                                    name="phone"
                                    icon="icon icon-user"
                                    icon-pack="feather"
                                    label-placeholder="邮箱/手机号"
                                    v-model="phone"
                                    class="w-full no-icon-border"/>

                                <vs-input
                                    type="password"
                                    name="password"
                                    icon="icon icon-lock"
                                    icon-pack="feather"
                                    label-placeholder="密码"
                                    v-model="password"
                                    class="w-full mt-6 no-icon-border" />

                                <div class="flex flex-wrap justify-between my-5">
                                    <vs-checkbox v-model="checkbox_remember_me" class="mb-3">记住账号密码</vs-checkbox>
                                    <router-link to="#">找回账号密码</router-link>
                                </div>
                                <vs-button  class="float-right" type="border" @click="registerUser">注册</vs-button>
                                <vs-button  @click="login">登录</vs-button>

                                <vs-divider></vs-divider>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
export default {
    data() {
        return {
            phone: '',
            password: '',
            checkbox_remember_me: false
        }
    },
	methods:{
		login(){	//登录
			if(this.phone==''||this.password==''){
				this.$vs.notify({
				  color:'warning',
				  title:'提示',
				  text:'请将内容填写完整'
				})
				return false;
			}
			this.$api.Login({password:this.password,phone:this.phone}).then(res=>{
				console.log("登录信息",res);
				if(res.code==0){
					var loginState=JSON.stringify(res.data);
					localStorage.setItem("loginState",loginState);
					localStorage.setItem("token",res.data.token);
					this.$vs.notify({
						  title:"登录成功",
						  color:'success',
						  position:'top-center'
					});
					this.$api.getuserinfo({}).then(res=>{  //获取当前登录用户信息
						console.log("当前用户：",res);
						this.$store.dispatch('getUserinfo',res.data);
						this.$router.push({path:'/'});
					})
				}else{
					this.$vs.notify({
						  title:"提示",
						  color:'warning',
						  text:res.message,
						  position:'top-center'
					});
				}
			}).catch(err=>{console.log("网络错误",err)})
		},
		registerUser() {  //注册
		    this.$router.push('/pages/register');
		}
	}
}
</script>

<style lang="scss" scoped="scoped">
#page-login {
    .social-login {
        .bg-facebook {
          background-color: #1551b1;
        }
        .bg-twitter {
          background-color: #00aaff;
        }
        .bg-google {
          background-color: #4285F4;
        }
        .bg-github {
          background-color: #333;
        }
    }
}
.p-8{
	padding: 5rem 2rem !important;
}
</style>
